module.exports = __webpack_public_path__ + "static/media/1.372faf7e.jpg";